import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      richColors
      closeButton
      expand
      gap={12}
      offset={20}
      visibleToasts={3}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:border group-[.toaster]:border-border/70 group-[.toaster]:rounded-2xl group-[.toaster]:px-4 group-[.toaster]:py-3.5 group-[.toaster]:gap-3 group-[.toaster]:shadow-[0_18px_45px_-12px_rgba(0,0,0,0.65)] group-[.toaster]:ring-1 group-[.toaster]:ring-primary/15",
          title: "group-[.toast]:text-[15px] group-[.toast]:font-bold group-[.toast]:leading-snug group-[.toast]:tracking-tight",
          description: "group-[.toast]:text-[13px] group-[.toast]:font-medium group-[.toast]:text-muted-foreground group-[.toast]:leading-snug",
          icon: "group-[.toast]:mt-0.5",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:rounded-lg group-[.toast]:font-semibold",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-lg",
          closeButton:
            "group-[.toast]:bg-card group-[.toast]:border-border group-[.toast]:text-muted-foreground hover:group-[.toast]:text-foreground",
        },
        style: {
          background: 'hsl(var(--card))',
          color: 'hsl(var(--card-foreground))',
          zIndex: 999999,
        },
      }}
      style={{ zIndex: 999999 }}
      {...props}
    />
  );
};

export { Toaster, toast };
